import loginAPI from '@/api/login'
import memberApi from '@/api/member'
import { getToken, setToken, removeToken } from '@/utils/auth'

const user = {
  state: {
    token: getToken(),
    user: {},
    roles: [],
    // 第一次加载菜单时用到
    loadMenus: false,
  },
  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_USER: (state, user) => {
      state.user = user
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles
    },
    SET_LOAD_MENUS: (state, loadMenus) => {
      state.loadMenus = loadMenus
    },
  },
  actions: {
    // 登录
    Login({ commit }, userInfo) {
      const rememberMe = userInfo.rememberMe
      return new Promise((resolve, reject) => {
        loginAPI
          .userLogin(userInfo)
          .then((res) => {
            console.log('login', res)
            if (res.data) {
              // console.log('1')
              setToken(res.data.token, rememberMe)
              commit('SET_TOKEN', res.data.token)
            }
            // setUserInfo(res.user, commit)
            // 第一次加载菜单时用到， 具体见 src 目录下的 permission.js
            // commit('SET_LOAD_MENUS', true)
            resolve(res)
            // resolve()
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    // 获取用户信息
    GetInfo({ commit }) {
      return new Promise((resolve, reject) => {
        memberApi
          .getMemberInfo()
          .then((res) => {
            // console.log('GetInfo', res)
            var mresult = {
              user: res,
              roles: ['admin'],
            }
            setUserInfo(mresult, commit)
            resolve(res)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },

    // GetInfo ({ commit }) {
    //   return new Promise((resolve, reject) => {
    //     // infoAPI.getPersonalInfo().then(res => {
    //     let result = {id: 1005, account: 'zengcong', password: '', name: '曾聪123', phoneBind: '13160651791', enable: 1, roleIds: null}
    //     var mresult = {
    //       user: result,
    //       roles: ['admin']
    //     }
    //     setUserInfo(mresult, commit)
    //     resolve(mresult)
    //     // }).catch(error => {
    //     //   reject(error)
    //     // })
    //   })
    // },
    // 登出
    LogOut({ commit }) {
      return new Promise((resolve, reject) => {
        loginAPI
          .loginOut()
          .then((res) => {
            logOut(commit)
            resolve()
          })
          .catch((error) => {
            logOut(commit)
            reject(error)
          })
      })
    },
    updateLoadMenus({ commit }) {
      return new Promise((resolve, reject) => {
        commit('SET_LOAD_MENUS')
      })
    },
  },
}

export const logOut = (commit) => {
  commit('SET_TOKEN', '')
  commit('SET_ROLES', [])
  removeToken()
  window.location.reload()
}

export const setUserInfo = (res, commit) => {
  // 如果没有任何权限，则赋予一个默认的权限，避免请求死循环
  if (res.roles.length === 0) {
    commit('SET_ROLES', ['ROLE_SYSTEM_DEFAULT'])
  } else {
    commit('SET_ROLES', res.roles)
  }
  commit('SET_USER', res.user)
}

export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js